<mat-card>
    <mat-card-header>
      <mat-card-title>Compra Mensual en el Supermercado</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field>
        <input matInput [formControl]="searchControl" placeholder="Buscar productos por nombre o categoría">
      </mat-form-field>
  
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort>
  
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="masterToggle($event.checked)" [checked]="isAllSelected()" [indeterminate]="isIndeterminate()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox (change)="toggleSelection(element)" [checked]="selection.isSelected(element)"></mat-checkbox>
          </td>
        </ng-container>
  
        <!-- Item Column -->
        <ng-container matColumnDef="item">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Producto </th>
          <td mat-cell *matCellDef="let element"> {{element.item}} </td>
        </ng-container>
  
        <!-- Price Column -->
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Precio (€) </th>
          <td mat-cell *matCellDef="let element"> {{element.price}} </td>
        </ng-container>
  
        <!-- Category Column -->
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Categoría </th>
          <td mat-cell *matCellDef="let element"> {{element.category}} </td>
        </ng-container>
  
        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSize]="10"></mat-paginator>
  
      <h3>Orden (Carrito)</h3>
      <table mat-table [dataSource]="selection.selected" class="mat-elevation-z8" multiTemplateDataRows>
        <!-- Item Column -->
        <ng-container matColumnDef="item">
          <th mat-header-cell *matHeaderCellDef> Producto </th>
          <td mat-cell *matCellDef="let element"> {{element.item}} </td>
        </ng-container>
  
        <!-- Price Column -->
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef> Precio (€) </th>
          <td mat-cell *matCellDef="let element"> {{element.price}} </td>
        </ng-container>
  
        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumnsCart"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsCart;"></tr>
      </table>
  
      <p>Total Seleccionado: {{totalPrice | currency}}</p>
    </mat-card-content>
  </mat-card>
